<template>
  <div class="featured">
    <div class="page">
      <div class="item" style="z-index: 1">
        <picture>
          <img :src="highlightedShow?.realFlyerPath ? highlightedShowImageUrl : 'https://ticketera-prod-storage.s3.amazonaws.com/plop/logoplop.png'">
        </picture>
        <div>
          <h6>+18</h6>
          <h2 v-if="highlightedShow!=={} && highlightedShow?.showEvents?.length > 0">
            <strong>
              <NuxtTime class="upperCase" :datetime="highlightedShow?.showEvents[0]?.startsAt" weekday="long" day="numeric" month="long" :locale="'es'"/>
            </strong>
            <span>
              <NuxtTime :datetime="highlightedShow?.showEvents[0].startsAt" hour="numeric" minute="numeric"/>
            </span>
          </h2>
          <h1>{{highlightedShow?.name ?? ''}}</h1>
          <h3>
            <strong>{{highlightedShow?.location?.name ?? ''}}</strong>
            {{highlightedShow?.location?.address ?? ''}},{{highlightedShow?.location?.city ?? ''}}
          </h3>
          <div v-if="highlightedShow!=={} && highlightedShow?.showEvents?.length > 0">
            <p>Entradas desde <strong>${{ highlightedShow?.showEvents[0]?.showPrices ? getMinPrice(highlightedShow.showEvents[0]?.showPrices) : '' }}</strong></p>
            <NuxtLink :href="highlightedShow ? highlightedShowPurchaseUrl : '/'" class="bt">Comprar entradas <i class="fa fa-arrow-right"/></NuxtLink>
          </div>
        </div>
      </div>
    </div>
    <main class="main main__home" role="main">
      <section id="shows" class="section">
        <h2>Próximos eventos 🎉 Próximos eventos 🎉 Próximos eventos 🎉 Próximos eventos 🎉 Próximos eventos 🎉 Próximos eventos 🎉</h2>
        <div class="page">
          <ul class="row list list__shows">
            <li v-for="show in shows" :key="`show_${show.id}`" class="col col4 listItem">
              <home-show-card :show="show"/>
            </li>
            <li v-if="shows.length === 0" class="null">
              <p>
                <i class="fa-solid fa-face-dizzy"/>
                {{ $t('home.noEvents') }}
                <a href="#" @click.prevent="cleanFilters">{{ $t('home.showAllEvents') }}</a>
              </p>
            </li>
          </ul>
        </div>
      </section>
      <popup-modal-component/>
      <about-component/>
    </main>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

import type {
  ListShows200Response,
  ListShowsModesEnum,
  ListShowsTypesEnum,
  ListShowsWhenDateInEnum, ShowPricePublicOutput, ShowPublicOutput
} from '~/api/generated'
import api from '../api'
import AboutComponent from '@/components/AboutComponent.vue'
import {getDay, getMonth} from '~/utils/DateHelper'
import {useBuyStore} from "~/storage/buyPreference";

const initialFiltersState = {
  nameOrDescription: undefined,
  types: {
    free: false,
    paid: true,
    donate: false,
    external: true,
  },
  modes: {
    online: false,
    inPlace: true
  },
  whenDateIn: {
    thisWeek: false,
    thisMonth: false
  },
  city: undefined
}

definePageMeta({layout: 'base-layout',});
export default defineComponent({
  name: 'HomeView',
  components: {AboutComponent},
  data() {
    return {
      loading: true as boolean,
      paginatedShowsResponse: {} as ListShows200Response,
      shows: [] as ShowPublicOutput[],
      highlightedShow: {} as ShowPublicOutput,
      nameOrDescription: '',
      filters: JSON.parse(JSON.stringify(initialFiltersState)),
      page: 1
    }
  },
  computed: {
    highlightedShowPurchaseUrl() {
      if (!this.highlightedShow) {
        return '';
      }
      if (this.highlightedShow.type === TYPE_EXTERNAL) {
        return this.highlightedShow?.externalUrl ?? '';
      }
      return this.highlightedShow ? `/shows/${this.highlightedShow.path}` : ''
    },
    highlightedShowImageUrl() {
      if (!this.highlightedShow) {
        return 'https://ticketera-prod-storage.s3.amazonaws.com/plop/logoplop.png';
      }

      let selectedFlyer = null;
      if (this.highlightedShow.showFlyers.length > 1) {
        this.highlightedShow.showFlyers.forEach((item) => {
          if (item.realFlyerPath !== this.highlightedShow.realFlyerPath) {
            selectedFlyer = item.realFlyerPath;
          }
        });

      }
      return selectedFlyer ? selectedFlyer : this.highlightedShow.realFlyerPath
    }
  },
  watch: {
    filters: {
      handler: async function () {
        this.loading = true
        this.page = 1
        this.shows = [] as ShowPublicOutput[]
        await this.fetchUsingFilters()
      },
      deep: true
    }
  },
  async mounted() {
    await this.consumeShowsApi()
    this.highlightedShow = this.shows[Math.floor(Math.random() * this.shows.length)]
    window.addEventListener('scroll', this.handleScroll)
    const buyStore = await useBuyStore();
    buyStore._reset();
    useSeoMeta({
      title: 'Plop',
      ogTitle: 'Plop.com.ar',
      description: 'Plop.',
      ogDescription: 'Fiesta Plop!',
      twitterCard: 'summary_large_image',
    })
  },
  async unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getMonth,
    getDay,
    getMinPrice(showPrices: ShowPricePublicOutput[]) {
      return Math.min(...showPrices.map(item => item.priceIncludesPlatformFee ? item.price + (item.platformFee ?? 0) : item.price))
    },
    cleanFilters() {
      this.filters = JSON.parse(JSON.stringify(initialFiltersState))
    },
    handleScroll() {
      if (this.page < this.paginatedShowsResponse.last_page) {
        ++this.page
      } else {
        return
      }
      this.consumeShowsApi()
    },
    calculateFilterClass(isEnabled: boolean | undefined) {
      return isEnabled ? 'active' : ''
    },
    calculateObjectFilters(filterObject: object) {
      const result = []
      for (const key in filterObject) {
        // @ts-expect-error
        if (filterObject[key] === true) {
          result.push(key)
        }
      }
      return result
    },
    async consumeShowsApi() {
      await api.Shows.listShows(
          this.nameOrDescription,
          undefined,
          this.calculateObjectFilters(this.filters.types) as ListShowsTypesEnum[],
          this.calculateObjectFilters(this.filters.whenDateIn) as ListShowsWhenDateInEnum[],
          this.calculateObjectFilters(this.filters.modes) as ListShowsModesEnum[],
          this.page
      ).then((result) => {
        this.paginatedShowsResponse = result.data
        this.shows.push(...this.paginatedShowsResponse.data)
        this.loading = false
      })
    },
    async fetchUsingFilters() {
      this.page = 1
      await api.Shows.listShows(
          this.nameOrDescription,
          undefined,
          this.calculateObjectFilters(this.filters.types) as ListShowsTypesEnum[],
          this.calculateObjectFilters(this.filters.whenDateIn) as ListShowsWhenDateInEnum[],
          this.calculateObjectFilters(this.filters.modes) as ListShowsModesEnum[],
          this.page
      ).then((result) => {
        this.paginatedShowsResponse = result.data
        this.shows = this.paginatedShowsResponse.data
        this.loading = false
      })
    }
  }
})
</script>